import { addDays, addMonths } from 'date-fns';

const LicenceRank = {
  BASIC: 0,
  PRO: 1,
  INTERACTIVE: 2,
  FLOW: 3,
};

const LicenceRanks = {
  BASIC: LicenceRank.BASIC,
  PRO: LicenceRank.PRO,
  PRO_TRIAL_30DAYS: LicenceRank.PRO,
  INTERACTIVE: LicenceRank.INTERACTIVE,
  INTERACTIVE_TRIAL_30DAYS: LicenceRank.INTERACTIVE,
  FLOW: LicenceRank.FLOW,
  FLOW_TRIAL_30DAYS: LicenceRank.FLOW,
};

const PurchasedLicenceRanks = {
  PRO: LicenceRank.PRO,
  INTERACTIVE: LicenceRank.INTERACTIVE,
  FLOW: LicenceRank.FLOW,
};

export const hasSuitableLicence = (licence, userLicence, purchasedOnly) => {
  if (purchasedOnly) {
    return hasPurchasedSuitableLicence(licence, userLicence);
  }

  if (licence === 'BETA') {
    return true;
  }

  return LicenceRanks[userLicence] >= LicenceRanks[licence];
};

export const hasPurchasedSuitableLicence = (licence, userLicence) => {
  return PurchasedLicenceRanks[userLicence] >= PurchasedLicenceRanks[licence];
};

const hasTrialLicence = (licence) => licence ===licence.includes('TRIAL');

const getRemainingTrialDays = (trialEndsAt) => {
  const dateOneUTC = Date.UTC(trialEndsAt.getFullYear(), trialEndsAt.getMonth(), trialEndsAt.getDate());
  const today = new Date();
  const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const difference = dateOneUTC - todayUTC;
  return difference / (1000 * 60 * 60 * 24);
};

const isFreeLicence = (licence) => licence === 'BASIC' || LicenceS.hasTrialLicence(licence);

const trialRedeemable = (jwtClaims) => {
  const { licence, trialEndsAt, webSessions } = jwtClaims;
  const trialEndsDate = new Date(trialEndsAt);
  const test = addMonths(trialEndsDate, 3).getTime() <= new Date().getTime();
  return licence === 'BASIC' && webSessions && webSessions < 5 && test;
};

export const LicenceS = {
  getRemainingTrialDays,
  hasTrialLicence,
  isFreeLicence,
  trialRedeemable,
};
